import React from 'react'
import PropTypes from 'prop-types'

import { styled } from '@mui/material/styles'

const StyledRoot = styled('div')({
  display: 'inline-block',
  whiteSpace: 'nowrap'
})

const iconSx = {
  verticalAlign: 'middle',
  marginRight: 1
} as const

const Text = ({ icon: Icon, children }) => (
  <StyledRoot>
    {Icon && <Icon style={{ verticalAlign: 'middle', marginRight: 8 }} />}
    {children}
  </StyledRoot>
)
Text.propTypes = {
  icon: PropTypes.any,
  children: PropTypes.any.isRequired
}

export default Text
